import React from 'react';
import pluralize from 'pluralize';

import { Layout, ProductImg, Text } from 'ds';
import AddQuantity from 'ds/AddQuantity';
import { formatUsd } from 'helpers';
import { ConsumablesProductSubscription } from 'shared';

interface ConsumablesOnboardingCartItemCardProps {
  consumablesProductSubscription: ConsumablesProductSubscription;
  handleDecreaseQuantity: () => void;
  handleIncreaseQuantity: () => void;
}

const ConsumablesOnboardingCartItemCard: React.FC<ConsumablesOnboardingCartItemCardProps> = ({
  consumablesProductSubscription,
  handleDecreaseQuantity,
  handleIncreaseQuantity
}) => {
  return (
    <Layout flex direction="row" gap={16} align="center">
      <ProductImg
        srcKey={consumablesProductSubscription.consumables_product.image_key}
        size="sm"
        alt={consumablesProductSubscription.consumables_product.detail}
        style={{ width: 72, height: 72, borderRadius: 8 }}
      />
      <Layout flex direction="column" gap={4} width={223} maxWidth={223}>
        <Text size="body-sm" maxLines={2}>
          {consumablesProductSubscription.consumables_product.brand}{' '}
          {consumablesProductSubscription.consumables_product.detail}{' '}
          {pluralize(consumablesProductSubscription.consumables_product.unit_type ?? '', 2)} (
          {consumablesProductSubscription.consumables_product.units_per_package}/
          {consumablesProductSubscription.consumables_product.package_type})
        </Text>
        <Text size="body-sm" semibold>
          {formatUsd(consumablesProductSubscription.consumables_product.amount_cents / 100)} ea.
        </Text>
      </Layout>
      <Layout width={124} minWidth={124}>
        <AddQuantity
          value={consumablesProductSubscription.order_quantity}
          size="sm"
          handleDecreaseQuantity={handleDecreaseQuantity}
          handleIncreaseQuantity={handleIncreaseQuantity}
          minValue={0}
        />
      </Layout>
    </Layout>
  );
};

export default ConsumablesOnboardingCartItemCard;
